export default __webpack_public_path__ + "static/media/FAHSA-Group-PAIA-Policy-signed.4d7d2ea0.pdf";